import { CUIDARI_ACCESS_GATE_COPY } from '@francisquiniai/cuidari-core/auth'
import { icon } from './shared'

export function BrandLockup() {
  return (
    <div className="login-brand">
      <div className="login-brand__mark" aria-hidden="true">
        {icon('favorite')}
      </div>
      <div>
        <h1 id="login-heading" data-testid="cuidari-wordmark">
          {CUIDARI_ACCESS_GATE_COPY.brand.wordmark}
        </h1>
        <p data-testid="cuidari-tagline">
          {CUIDARI_ACCESS_GATE_COPY.brand.tagline}
        </p>
      </div>
    </div>
  )
}

export function ReleaseTeaser() {
  const teaser = CUIDARI_ACCESS_GATE_COPY.releaseTeaser
  return (
    <a className="login-release" href={teaser.href} data-testid="login-release-teaser">
      <div className="login-release__icon" aria-hidden="true">
        {icon('how_to_vote')}
      </div>
      <div className="login-release__copy">
        <div className="login-release__meta">
          <span>{teaser.kicker}</span>
          <span className="login-live-pill">{teaser.liveLabel}</span>
        </div>
        <p>{teaser.title}</p>
        <div className="login-release__stats" aria-hidden="true">
          <span>{icon('forum')} {teaser.stats[0]}</span>
          <span>{icon('verified_user')} {teaser.stats[1]}</span>
        </div>
      </div>
    </a>
  )
}
